export const MINI_CARD_VIEW = 'mini-card';
export const FULL_PROFILE_VIEW = 'full-profile';
